<template>
  <main>
    <fade-in-top-title class="title-interval">
      <div class="works-list-wrapper">
        <ul class="works-list">
          <li
          v-for="workList in workLists"
          :key="workList.id">
            <input
            type="radio" 
            :id="workList"
            :value="workList"
            v-model="preview">
            <label :for="workList">{{ workList }}</label>
          </li>
        </ul>
      </div>
    </fade-in-top-title>
    <fade-in-main>
      <div class="container container-works">
        <transition-group name="fade" class="works-contents">
          <article v-for="(workContent,index) in workContents"
          :key="workContent.id"
          v-show="workContent.display"
          @mouseover="mouseOverAction(index)"
          @mouseleave="mouseLemoveAction(index)">
            <router-link :to="workContent.to">
            <img :src="workContent.src">
              <transition name="fade">
                <div v-show="imgTitle && index === imgIndex "
                class="works-contents-img">
                  <div class="works-contents-img-title">
                    <h3>{{ workContent.title }}</h3>
                    <p>{{ workContent.subtitle }}</p>
                  </div>
                </div>
              </transition>
            </router-link>
          </article>
        </transition-group>
      </div>
    </fade-in-main>
  </main>
</template>


<script>
import FadeInMain from '@/components/FadeInMain.vue';
import FadeInTopTitle from '@/components/FadeInTopTitle.vue';
import { WorkPreview } from '@/WorkPreview';

export default {
  data() {
    return {
      workContents: [
        {
          id: 1,
          title: 'introduction',
          subtitle: 'このサイトについて',
          src: require('@/assets/images/introduction01.png'),
          categories: ['All','Vue.js'],
          display: true,
          to: '/introduction'
        },
        {
          id: 2,
          title: 'Wine_UENO',
          subtitle: '社内のカリキュラムで制作物',
          src: require('@/assets/images/works-01_ueno-wine.png'),
          categories: ['All','Html/Css/Js'],
          display: true,
          to: '/work/workContents01'
        },
        {
          id: 3,
          title: 'Instagram 働く＆リフレッシュキャンペーン',
          subtitle: '社内のカリキュラムで制作',
          src: require('@/assets/images/works-02_abbeco.png'),
          categories: ['All','Html/Css/Js'],
          display: true,
          to: '/work/workContents02'
        },
        {
          id: 4,
          title: 'pf fashion',
          subtitle: '個人で制作',
          src: require('@/assets/images/works-03_my-portfolio.png'),
          categories: ['All','Html/Css/Js'],
          display: true,
          to: '/work/workContents03'
        },
        {
          id: 5,
          title: 'googleMap',
          subtitle: '個人で制作',
          src: require('@/assets/images/works-04_vue-googleMap.png'),
          categories: ['All','Vue.js'],
          display: true,
          to: '/work/workContents04'
        },
        {
          id: 6,
          title: 'Webアプリ試作 Google Apps Script',
          subtitle: '社内のカリキュラムで制作',
          src: require('@/assets/images/works-05_gas-calendar.png'),
          categories: ['All','Google Apps Script'],
          display: true,
          to: '/work/workContents05'
        },
        {
          id: 7,
          title: '小林製薬 CM',
          subtitle: '前職で制作',
          src: require('@/assets/images/works-07_ps-kobayashi.png'),
          categories: ['All','Photoshop/Illustrator'],
          display: true,
          to: '/work/workContents06'
        },
        {
          id: 8,
          title: 'AOKI CM',
          subtitle: '前職で制作',
          src: require('@/assets/images/works-09_ai-aoki.png'),
          categories: ['All','Photoshop/Illustrator'],
          display: true,
          to: '/work/workContents07'
        }
      ]
    }
  },
  mixins: [ WorkPreview ],
  components: {
    FadeInMain,FadeInTopTitle
  }
}
</script>

<style lang="scss" scoped>

.works-list-wrapper {
  display: flex;
  justify-content: center;
}

.works-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
 li {
    font-size: 20px;
    margin: 0 20px;
    text-align: left;
    position: relative;
    display: inline-block;
    text-decoration: none;
    line-height: 30px;
    &::after {
      position: absolute;
      left: 0;
      content: '';
      width: 0;
      bottom: -2px;
      height: 2px;
      background: $colorBrown;
      opacity: 0;
      visibility: hidden;
      transition: .3s;
    }
    input {
      display: none;
    }
  }
  label {
    cursor: pointer;
  }
}

.works-list > li:hover::after,
.works-list > li:focus::after {
  opacity: 1;
  width: 100%;
  visibility: visible;
}


</style>